export function activities(state){
    return state.activities
}

export function downloading(state){
    return state.downloading
}